import { mainLayoutStyles } from "components/Layout/layoutStyles";
import styled from "styled-components";

const MasterLayoutStyleHTML = styled.div`
    ${mainLayoutStyles}
`;

export const MasterLayout = styled(MasterLayoutStyleHTML).attrs(() => ({ className: "aevi-master" as string }))``;
